import { call, debounce, put } from 'redux-saga/effects';
import { fetchSubstrateList } from '../../services/substrateService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import { FETCH_SUBSTRATE_LIST } from './substrate.actions';

function* fetchSubstrateListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const response = yield call(fetchSubstrateList, action.payload);
    const { data, headers } = response;
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchSubstrate() {
  yield debounce(250, FETCH_SUBSTRATE_LIST, fetchSubstrateListSaga);
}
